import { FoodsIllustrations } from "@foodpilot/foods";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type EmptyCardProps = {
    direction?: "row" | "column";
};

export const EmptyCard = (props: EmptyCardProps) => {
    const { direction = "row" } = props;
    const { t } = useTranslation();

    return (
        <Stack
            direction={direction}
            spacing={4}
            alignItems="center"
            justifyContent="flex-start"
            sx={{
                width: "100%",
                textAlign: direction === "row" ? "left" : "center",
            }}
        >
            <FoodsIllustrations illustration="notEnoughData" />
            <Stack spacing={1}>
                <Typography variant="h4">{t("score.details.comparison.nodata.title")}</Typography>
                <Typography variant="body">{t("score.details.comparison.nodata.description")}</Typography>
            </Stack>
        </Stack>
    );
};
